import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/Button';

import Api from '../../Api';

export default class Code extends React.Component {
  constructor(props) {
    super(props);

    this.onSignIn = this.onSignIn.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onChange = this.onChange.bind(this);

    this.state = {
      invalidCode: false,
      code: ''
    };
  }

  onKeyPress(event) {
    if (event.key === 'Enter') {
      return this.refs.submit.click(event);
    }
  }

  onChange(event) {
    if (event.defaultPrevented) return;

    let initialValue = event.target.value || '';
    let value = initialValue.replace(/\D/g, '');

    this.setState({
      code: value
    });
  }

  onSignIn() {
    this.setState({ invalidCode: false });

    return Api.userLogin(this.props.params.email, this.refs.credential.value)
      .then(
        (user) => {
          if (!user) {
            this.setState({ invalidCode: true });
          } else {
            let defaultRedirect = user.retailer_token ? `/retailer/${user.retailer_token}` : '/';
            this.context.router.push(this.props.location.query.redirect || defaultRedirect);
          }
        }
      );
  }

  render() {
    return(
      <div className="page-flyout signin">
        <h2>Sign In</h2>
        <p className="note">Enter the access code we sent to <strong>{this.props.params.email}</strong>.</p>
        <div className="input">
          <input type="text" ref="credential" placeholder="Confirmation Code" className="center" pattern="\d*" value={this.state.code} onChange={this.onChange} onKeyPress={this.onKeyPress} />
        </div>
        <div className={ this.state.invalidCode ? '' : 'hidden' }>Invalid code</div>
        <div>
          <Button ref="submit" onClick={this.onSignIn}>Sign In</Button>
        </div>
      </div>
    );
  }
}

Code.contextTypes = {
  router: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/views/user/code.js
 **/